import type { Theme } from '../..';

import '../../build/typography.css';
import '../../build/colors.css';
import '../../build/hrDark/color.css';
import '../../build/static/color.css';
import '../../legacy.css';
import '../../control.css';
import '../../build/root.css';
import '../../controls/index.css';
import '../legoOverrides.css';

export const theme: Theme = {
    color: 'hrDark',
    root: 'hrDark',
};
